module.exports = __webpack_public_path__ + "static/img/daijin.e6a8b7ca.png";